<template>
  <qx-card title="报表">
    <!-- <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section> -->
    <el-table
      :data="tableData.data"
      style="width: 100%"
      row-key="id"
      lazy
      :load="load"
      :tree-props="{
        children: 'children',
        hasChildren: 'hasChildren',
      }"
    >
      <template v-for="(item, index, key) in tableData.title">
        <el-table-column
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
          :fixed="item.fixed"
        >
          <span v-if="item.children">
            <el-table-column
              v-for="(childItem, childIndex, childKey) in item.children"
              :key="childKey"
              :prop="childItem.prop"
              :label="childItem.label"
              :min-width="childItem.minW"
              :width="childItem.w"
            />
          </span>
        </el-table-column>
      </template>
    </el-table>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
// import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    // TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            label: '客户名称',
            prop: 'customerName',
            fixed: true,
            w: 200,
          },
          {
            label: '概要信息',
            children: [
              {
                label: '发车趟数',
                prop: '1',
              },
              {
                label: '自有车公里数',
                prop: '2',
              },
              {
                label: '自有车单公里收入',
                prop: '3',
              },
              {
                label: '车头数',
                prop: '4',
              },
              {
                label: '车挂数',
                prop: '5',
              },
              {
                label: '车头挂汇总',
                prop: '6',
              },
            ],
          },
          {
            label: '业务收入',
            children: [
              {
                label: '自有车收入',
                prop: '1',
              },
              {
                label: '外调车收入',
                prop: '2',
              },
              {
                label: '客户调整',
                prop: '3',
              },
              {
                label: '其他业务收入',
                prop: '4',
              },
              {
                label: '业务收入合计',
                prop: '5',
              },
            ],
          },
          {
            label: '主营成本',
            children: [
              {
                label: '加油费',
                prop: '1',
              },
              {
                label: '加油升数',
                prop: '2',
              },
              {
                label: '加油价格',
                prop: '3',
              },
              {
                label: '加油挂牌价',
                prop: '4',
              },
              {
                label: '当前油耗',
                prop: '5',
              },
              {
                label: 'G7油耗',
                prop: '6',
              },
              {
                label: '过路费',
                prop: '7',
              },
              {
                label: '劳务费',
                prop: '8',
              },
              {
                label: '外调车费用',
                prop: '9',
              },
              {
                label: '装卸费',
                prop: '10',
              },
              {
                label: '压车费',
                prop: '11',
              },
              {
                label: '品质罚款',
                prop: '12',
              },
              {
                label: '运营费用合计',
                prop: '13',
              },
              {
                label: '车辆折旧费',
                prop: '14',
              },
              {
                label: '维修费',
                prop: '15',
              },
              {
                label: '保养费',
                prop: '16',
              },
              {
                label: '轮胎费',
                prop: '17',
              },
              {
                label: '年审',
                prop: '18',
              },
              {
                label: '保险',
                prop: '19',
              },
              {
                label: '违章',
                prop: '20',
              },
              {
                label: '事故',
                prop: '21',
              },
              {
                label: '停车费',
                prop: '22',
              },
              {
                label: 'GPS',
                prop: '23',
              },
              {
                label: '尿素',
                prop: '24',
              },
              {
                label: '杂费',
                prop: '25',
              },
              {
                label: '车辆费用合计',
                prop: '26',
              },
              {
                label: '主营成本合计',
                prop: '27',
              },
            ],
          },
          {
            label: '毛利润',
            children: [
              {
                label: '毛利润',
                value: '1',
              },
            ],
          },
          {
            label: '管理费用',
            children: [
              {
                label: '员工薪酬',
                value: '1',
              },
              {
                label: '办公费',
                value: '2',
              },
              {
                label: '招待费',
                value: '3',
              },
              {
                label: '差旅费',
                value: '4',
              },
              {
                label: '团建费',
                value: '5',
              },
              {
                label: '房租水电费',
                value: '6',
              },
              {
                label: '研发费',
                value: '7',
              },
              {
                label: '工程施工',
                value: '8',
              },
              {
                label: '咨询费',
                value: '9',
              },
              {
                label: '其他',
                value: '10',
              },
              {
                label: '管理费用合计',
                value: '11',
              },
            ],
          },
          {
            label: '财务费用',
            children: [
              {
                label: '税金成本',
                value: '1',
              },
              {
                label: '财务费用',
                value: '2',
              },
              {
                label: '财务费用合计',
                value: '3',
              },
            ],
          },
          {
            label: '合计',
            prop: 'total',
          },
        ],
        data: [ // 表格内容
          {
            'customerName': '陈皮',
            id: '123',
            '1': '1',
            '2': '2',
            '3': '3',
            hasChildren: true,
          },
        ],
      },
    };
  },
  methods: {
    load (tree, treeNode, resolve) {
      setTimeout(() => {
        resolve([
          {
            id: 31,
            'customerName': '陈皮1',
            '1': '1',
            '2': '2',
            '3': '3',
          },
          {
            id: 32,
            '1': '1',
            'customerName': '陈皮2',
            '2': '2',
            '3': '3',
          },
        ]);
      }, 1000);
    },
    getList () {
      const res = {
        items: [ // 表格内容
          {
            'customerName': '陈皮',
            id: '123',
            '1': '1',
            '2': '2',
            '3': '3',
            hasChildren: true,
          },
        ],
      };
      return res;
    },
  },
};
</script>

<style>
</style>
